<template>
 <v-layout
    justify-center
    class="activity"
    :style="{ 'width': isSimulation ? '375px' : `${sizeW}px !important`}"
  >
    <v-flex
      xs12
      style="padding-bottom: 0px;padding-top: 0px;padding-left: 20px;padding-right: 20px;"
    >
      <div
        style="padding-top: 15px; padding-bottom: 15px;font-size:22px;"
        class="text-center"
      >
        {{ $t(sDay.pre).toUpperCase() }} {{ $t(sDay.month).toUpperCase() }} {{ sDay.pos.toUpperCase() }}
      </div>
      <div
        style="border-radius:5px;position: static; top:0px;margin-bottom:20px;margin-top:20px;"
        :style="{ 'background-color': `${primaryColor}` }"
      >
        <v-btn-toggle v-model="daysToAdd" style="width: 100%;"
          :style="{ 'background-color': `${secundaryColor}` }"
        >
          <v-btn
            v-for="(day, index) in week"
            :key="`week${index}`"
            style="width:14.3%;min-width:14.2%;"
            :style="{ 'color': secundaryColor }"
            @click="() => handleAddDays(index)"
            :disabled="index === daysToAdd"
            :dark="!isLight(secundaryColor)"
            :light="isLight(secundaryColor)"
          >
            <span :class="`btn-day-${index}`" :style="{
                'color': isLight(secundaryColor) ? 'black' : 'white',
              }">{{ $t(`common.${day}Small`, locale).substring(0, 2) }}</span>
           <!-- {{ $t(`common.${day}`).substring(0, 2) }} -->
          </v-btn>
        </v-btn-toggle>
      </div>
      <!-- <div
        style="opacity: 0.8;position: static; height:64px;top:0px;margin-bottom:20px;"
        :style="{ 'background-color': `${BGColor}` }"
      >
        <table border="0" style="width:100%;height:100%;border:0px;" cellspacing="0" cellpadding="0">
          <tr>
            <td class="td" v-for="(day, index) in week"
              :key="`td${index}`"
              :style="{ 'padding-top': isSimulation || isDesktop ? '20px' : '','background-color': daysToAdd === index ? ColorContent : BGColor, 'border-right': index !== 6 ? '1px solid white' : '0px' }"
              style="text-align: center;color:white;width:14.19%"
              @click="() => handleAddDays(index)"
            >
              {{ $t(`common.${day}`).substring(0, 2) }}
            </td>
          </tr>
        </table>
      </div> -->
      <v-container
        fluid
        grid-list-md
      >
        <v-layout
          row
          wrap
          style="margin-bottom: 20px;"
        >
          <v-flex
            v-if="loading"
            style="margin: 15px;text-align: center;padding-top:10px;padding-bottom:10px;opacity:0.9;"
          >
            <v-progress-circular
              :size="70"
              :width="7"
              color="#CCCCCC"
              indeterminate
            />
          </v-flex>
          <v-flex
            v-if="shows && shows.length === 0"
            :style="{ 'background-color': ColorContent, 'color': BGColorContent }"
            style="margin: 15px;text-align: center;padding-top:10px;padding-bottom:10px;opacity:0.9;"
          >
            {{ $t('activity.messages.noActivities').toUpperCase() }}
          </v-flex>
          <v-flex
            v-for="(show, index) in shows"
            :key="show.ID"
            v-bind="{ [`xs${isTotem && shows.length > 0 ? 6 : 12}`]: true }"
            style="margin-top: 5px;margin-bottom: 6px;"
            :style="{ padding: !isTotem || shows.length < 2 ? '0 0 0 0' : index % 2 === 0 ? '0 10px 0 5px' : '0 5px 0 10px' }"
          >
            <!-- {{index}}
            <br>
            {{show}} -->
            <v-card
              class="mx-auto"
              max-width="344px"
              :style="{ 'opacity': show.Availability.finished ? '0.3' : '1' }"
            >
              <v-img
                :src="show.Image"
                height="auto"
              ></v-img>
              <v-card-title>
                <v-layout
                  row
                  wrap
                  style="margin-top:5px;margin-bottom:0px;"
                >
                  <v-flex
                    xs8
                    style="font-size: 16px;line-height:1.2;"
                    :style="{ 'color': titleColor}"
                  >
                    {{ show.Title.toUpperCase() }}
                  </v-flex>
                  <v-flex
                    xs4
                    style="text-align: right;padding-right: 15px;padding-bottom:0px;"
                  >
                    <add-calendar
                      v-if="!isPI && !isSimulation && show && !show.Availability.finished && !isTotem"
                      :start="show.Date"
                      :end="show.Date"
                      :startTime="show.TimeStart"
                      :endTime="show.TimeEnd"
                      :title="show.Title"
                      :description="show.Description ? show.Description : ''"
                      :color="secundaryColor"
                      :active="daysToAdd === 0 && show.Availability.time"
                    />
                  </v-flex>
                </v-layout>
                <div style="width: 100%">
                  <v-icon
                    :style="{ 'color': show.Availability.time && show.Availability.daysToAdd === '0' ? 'rgb(85,173,11)' : ColorContent}"
                    dark
                    class="activity-button"
                    style="margin-left: 0px;font-weight: 500;font-size: 17px;"
                  >
                    mdi-clock-outline
                  </v-icon>
                  <span
                    :style="{ 'color': show.Availability.time && show.Availability.daysToAdd === '0' ? 'rgb(85,173,11)' : ColorContent}"
                    style="margin-left: 0;font-weight: 500;font-size: 17px;"
                  >
                    {{ show.TimeStart.substring(0, 5) }}-{{ show.TimeEnd.substring(0, 5) }}
                  </span>
                </div>
                <div style="width: 100%">
                  <span
                    style="margin-left: 0;font-size: 13px;"
                    :style="{ 'color': ColorContent}"
                  >{{ show.Site }}</span>
                </div>
                <div
                  style="margin-bottom: 5px;margin-left: 0;font-size: 13px;width: 100%;line-height:normal"
                  v-if="show.Description && show.Description.length > 0"
                  :style="{ 'color': `${descriptionColor} !important`}"
                >
                  {{ show.Description }}
                </div>
              </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
  import {
    mapState
  } from 'vuex'
   import tinycolor from 'tinycolor2'
  import utils from '@/services/utils'
  import axios from 'axios'
  import api from '@/services/api'
  import constants from '@/constants'
  import AddCalendar from './AddCalendar'
  export default {
    components: {
      AddCalendar
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null,
      }
    },
    data: () => ({
      loading: false,
      DviewLink: null,
      shows: null,
      daysToAdd: 0,
      week: [],
      typeShow: 0,

      titleColor: null,
      descriptionColor: null,
      primaryColor: null,
      secundaryColor: null,
      colorShowContent: null
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'BGColorContent', 'BGColor', 'ColorContent']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile();
      },
      isTotem () {
        return this.$route.path.indexOf('/totem') >= 0 || utils.isTotem()
      },
      isPI () {
        if (this.$route.query.PI) return true
        return false
      },
      sizeW () {
        return window.innerWidth - (!utils.isMobile() ? 360 : 0)
      },
      sDay () {
        let dToday = new Date()
        const dActual = new Date().setDate(dToday.getDate() + this.daysToAdd)
        const pos = `${new Date(dActual).getDate()}, ${new Date(dActual).getFullYear()}`

        const result = {
          pre: this.daysToAdd === 0 ? 'common.today' : this.daysToAdd === 1 ? 'common.tomorrow' : '',
          month: `common.m${new Date(dActual).getMonth()}`,
          pos
        }
        return result
      }
    },
    watch: {
      'data.TypeShow': {
        handler: function (newValue) {
          this.typeShow = newValue
          this.handleGetShows()
        },
        deep: true
      },
      'data.ShowPrimaryColor': {
        handler: function (newValue) {
          this.checkShowPrimaryColor()
        },
        deep: true
      },
      'data.ShowSecundaryColor': {
        handler: function (newValue) {
          this.checkShowSecundaryColor()
        },
        deep: true
      },
      'data.ShowColor': {
        handler: function (newValue) {
          this.checkShowTitleColor()
        },
        deep: true
      },
      'data.ShowDescriptionColor': {
        handler: function (newValue) {
          this.checkShowDescriptionColor()
        },
        deep: true
      },
    },
    mounted () {
      this.checkShowPrimaryColor()
      this.checkShowSecundaryColor()
      this.checkShowTitleColor()
      this.checkShowDescriptionColor()

      this.typeShow = this.data.TypeShow ? this.data.TypeShow : 0
      this.prepareWeek()
      /*
      const dSemenaActual = new Date().getUTCDay() - 1
      const aux = []
      for (let i = 0; i < 7; i++) {
        let x = ((dSemenaActual + i) >= 7) ? (dSemenaActual + i - 7) : dSemenaActual + i
        if (x === -1) x = 6
        aux.push(`s${x}`)
      }
      this.week = aux
      */
      this.getEnterprise()
    },
    methods: {
      async prepareWeek () {

        // const dSemenaActual = new Date().getUTCDay() - 1
        const dSemenaActual = new Date().getDay() - 1
        const aux = []
        for (let i = 0; i < 7; i++) {
          let x = ((dSemenaActual + i) >= 7) ? (dSemenaActual + i - 7) : dSemenaActual + i
          if (x === -1) x = 6
          aux.push(`s${x}`)
        }
        this.week = aux
      },
      async getOpacity (d) {
        const aux = await new Promise((resolve, reject) =>axios.get(`https://www.dviewcontent.com/api/p_show/${this.DviewLinkShows}/dtouch?config=true&daysToAdd=${d}&type=${this.typeShow}`)
            .then(response => {
            //console.log('aaaa', d, response.data.items)
              if (response && response.data && response.data.items && response.data.items.length > 0 ? true : false) resolve('100%')
              else resolve('30%')
            })
            .catch (error => {
              resolve ('100%')
            }))
        const elements = document.querySelectorAll(`.btn-day-${d}`)
        for(var i=0; i<elements.length; i++){
            elements[i].style.opacity = aux
        }
        //console.log('aaaaabbbbb', d, aux)
        return aux
      },
      isLight (value) {
        return tinycolor(value).isLight()
      },
      checkShowPrimaryColor (){
        this.primaryColor = this.data.ShowPrimaryColor ? this.data.ShowPrimaryColor : this.BGColor
      },
      checkShowSecundaryColor (){
        this.secundaryColor = this.data.ShowSecundaryColor ? this.data.ShowSecundaryColor : this.BGColorSecundary
      },
      checkShowTitleColor (){
        this.titleColor = this.data.ShowColor ? this.data.ShowColor : this.ColorContent
        this.colorShowContent = this.data.ShowSecundaryColor ? this.data.ShowSecundaryColor : this.ColorContent
      },
      checkShowDescriptionColor (){
        this.descriptionColor = this.data.ShowDescriptionColor ? this.data.ShowDescriptionColor : this.ColorContent
      },
      getEnterprise () {
        api.getItem('enterprises', false, this.$store.state.app.enterpriseID).then(response => {
          this.DviewLinkShows = response.DviewLinkShows
          for (let i = 0 ; i < 7; i++) {
            this.getOpacity(i)
          }

          this.handleGetShows()
        })
      },
      handleAddDays (value) {
        this.daysToAdd = value
        this.handleGetShows(this.daysToAdd)
      },
      handleGetShows () {
        this.loading = true
        this.activities = axios.get(`https://www.dviewcontent.com/api/p_show/${this.DviewLinkShows}/dtouch?config=true&daysToAdd=${this.daysToAdd}&type=${this.typeShow}`)
          .then(response => {
            if (response.data && response.data.items) {
              this.shows = response.data.items.map((item) => {
                // se hace esto ya que ponen saltos de línea en dviewcontent para el html de los players
                item.Site = utils.replaceAll(item.Site, '<br>',' ')
                item.Site = utils.replaceAll(item.Site, '</br>',' ')
                item.Site = utils.replaceAll(item.Site, '<BR>',' ')
                item.Site = utils.replaceAll(item.Site, '</BR>',' ')
                return item
              })
            } else {
              this.shows = []
            }
            this.shows = response.data && response.data.items ? response.data.items : []
            this.loading = false
          })
          .catch (err => {
            this.loading = false
          })
      }
    }
  }
</script>
<style scoped>
  .activity .container {
    padding: 0px;
  }
  .layout.activity.justify-center {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
  .activity .v-toolbar__content {
    padding: 0px !important;
    margin: auto !important;
  }
  .activity-button {
    margin-left: 10px;
  }
  .activity-button:hover {
    opacity: 0.7;
  }
  .td:hover {
    cursor: pointer;
  }
</style>
